import { Container, Grid, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Docs, DocsSidebar } from '../components/Docs';
import { Footer } from '../components/Layout/Footer';

export function DocsPage() {
  const { t } = useTranslation();

  return (
    <>
      <Container size="xl" px="md" py={48}>
        <Stack gap={48} mb={48}>
          <Title order={1} size="2.5rem" fw={700} lh={1.1} style={{ letterSpacing: '-0.02em' }}>
            {t('docs.pageTitle')}
          </Title>
          <Text size="lg" c="dimmed" maw={720}>
            {t('docs.pageDescription')}
          </Text>
        </Stack>

        <Grid gutter={48} align="stretch">
          <Grid.Col span={{ base: 12, md: 3 }} visibleFrom="md">
            <DocsSidebar />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 9 }}>
            <Docs />
          </Grid.Col>
        </Grid>
      </Container>

      <Footer />
    </>
  );
}
